// File: src/components/SearchFilters.jsx
import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { BRANDS_MODELS } from "../data/brandsModels";
import PriceRangeSlider from "./PriceRangeSlider";
import "../styles/SearchFilters.css";

const SearchFilters = ({ onFilterChange }) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  
  const [filters, setFilters] = useState({
    brand: searchParams.get("brand") || "",
    model: searchParams.get("model") || "",
    budget: searchParams.get("budget") || "",
    minPrice: searchParams.get("minPrice") || "",
    maxPrice: searchParams.get("maxPrice") || "",
    fuelType: searchParams.get("fuelType") || "",
    year: searchParams.get("year") || "",
    minYear: searchParams.get("minYear") || "",
    maxYear: searchParams.get("maxYear") || "",
    kmDriven: searchParams.get("kmDriven") || "",
    minKm: searchParams.get("minKm") || "",
    maxKm: searchParams.get("maxKm") || "",
    bodyType: searchParams.get("bodyType") || "",
    transmission: searchParams.get("transmission") || "",
    location: searchParams.get("location") || "",
    color: searchParams.get("color") || "",
    seats: searchParams.get("seats") || "",
    rto: searchParams.get("rto") || "",
    ownerType: searchParams.get("ownerType") || "",
    availability: searchParams.get("availability") || ""
  });

  useEffect(() => {
    setFilters({
      brand: searchParams.get("brand") || "",
      model: searchParams.get("model") || "",
      budget: searchParams.get("budget") || "",
      minPrice: searchParams.get("minPrice") || "",
      maxPrice: searchParams.get("maxPrice") || "",
      fuelType: searchParams.get("fuelType") || "",
      year: searchParams.get("year") || "",
      minYear: searchParams.get("minYear") || "",
      maxYear: searchParams.get("maxYear") || "",
      kmDriven: searchParams.get("kmDriven") || "",
      minKm: searchParams.get("minKm") || "",
      maxKm: searchParams.get("maxKm") || "",
      bodyType: searchParams.get("bodyType") || "",
      transmission: searchParams.get("transmission") || "",
      location: searchParams.get("location") || "",
      color: searchParams.get("color") || "",
      seats: searchParams.get("seats") || "",
      rto: searchParams.get("rto") || "",
      ownerType: searchParams.get("ownerType") || "",
      availability: searchParams.get("availability") || ""
    });
  }, [searchParams]);

  const [expandedSections, setExpandedSections] = useState({
    brand: false,
    budget: false,
    priceRange: false,
    fuelType: false,
    year: false,
    kmDriven: false,
    bodyType: false,
    transmission: false,
    location: false,
    color: false,
    seats: false,
    rto: false,
    ownerType: false,
    availability: false
  });

  const [expandedBrand, setExpandedBrand] = useState(null);
  const [showBrandDropdown, setShowBrandDropdown] = useState(false);

  // Filter options
  const budgetOptions = [
    { value: "", label: "Any Budget" },
    { value: "Under ₹3 Lakh", label: "Under ₹3 Lakh" },
    { value: "₹3-5 Lakh", label: "₹3-5 Lakh" },
    { value: "₹5-8 Lakh", label: "₹5-8 Lakh" },
    { value: "₹8-12 Lakh", label: "₹8-12 Lakh" },
    { value: "₹12-15 Lakh", label: "₹12-15 Lakh" },
    { value: "Above ₹15 Lakh", label: "Above ₹15 Lakh" }
  ];

  const fuelTypeOptions = [
    { value: "", label: "All Types" },
    { value: "Petrol", label: "Petrol" },
    { value: "Diesel", label: "Diesel" },
    { value: "CNG", label: "CNG" },
    { value: "Electric", label: "Electric" },
    { value: "Hybrid", label: "Hybrid" }
  ];

  const yearOptions = [
    { value: "", label: "Any Year" },
    { value: "2023 & above", label: "2023 & above" },
    { value: "2021 & above", label: "2021 & above" },
    { value: "2019 & above", label: "2019 & above" },
    { value: "2017 & above", label: "2017 & above" },
    { value: "2015 & above", label: "2015 & above" },
    { value: "2013 & above", label: "2013 & above" },
    { value: "2011 & above", label: "2011 & above" },
    { value: "2009 & above", label: "2009 & above" }
  ];

  const kmDrivenOptions = [
    { value: "", label: "Any KM" },
    { value: "10,000 kms or less", label: "10,000 kms or less" },
    { value: "30,000 kms or less", label: "30,000 kms or less" },
    { value: "50,000 kms or less", label: "50,000 kms or less" },
    { value: "75,000 kms or less", label: "75,000 kms or less" },
    { value: "1,00,000 kms or less", label: "1,00,000 kms or less" },
    { value: "1,25,000 kms or less", label: "1,25,000 kms or less" },
    { value: "1,50,000 kms or less", label: "1,50,000 kms or less" },
    { value: "1,75,000 kms or less", label: "1,75,000 kms or less" }
  ];

  const bodyTypeOptions = [
    { value: "", label: "All Body Types" },
    { value: "Hatchback", label: "Hatchback" },
    { value: "Sedan", label: "Sedan" },
    { value: "SUV", label: "SUV" },
    { value: "MUV", label: "MUV" },
    { value: "Coupe", label: "Coupe" },
    { value: "Convertible", label: "Convertible" },
    { value: "Wagon", label: "Wagon" }
  ];

  const transmissionOptions = [
    { value: "", label: "All Transmission" },
    { value: "Automatic", label: "Automatic" },
    { value: "Manual", label: "Manual" }
  ];

  const locationOptions = [
    { value: "", label: "All Locations" },
    { value: "Indore", label: "Indore" },
    { value: "Mhow", label: "Mhow" },
    { value: "Pithampur", label: "Pithampur" },
    { value: "Dewas", label: "Dewas" },
    { value: "Ujjain", label: "Ujjain" }
  ];

  // ✅ COLOR OPTIONS
  const colorOptions = [
    { value: "", label: "All Colors", color: null },
    { value: "white", label: "White", color: "#FFFFFF" },  // Changed from "White" to "white"
    { value: "black", label: "Black", color: "#000000" },  // Changed from "Black" to "black"
    { value: "silver", label: "Silver", color: "#C0C0C0" }, // etc.
    { value: "grey", label: "Grey", color: "#808080" },
    { value: "red", label: "Red", color: "#DC143C" },
    { value: "blue", label: "Blue", color: "#1E90FF" },
    { value: "brown", label: "Brown", color: "#8B4513" },
    { value: "green", label: "Green", color: "#228B22" },
    { value: "orange", label: "Orange", color: "#FF8C00" },
    { value: "yellow", label: "Yellow", color: "#FFD700" }
  ];
  const seatsOptions = [
    { value: "", label: "All Seats" },
    { value: "4", label: "4 Seater" },
    { value: "5", label: "5 Seater" },
    { value: "6+", label: "6+ Seater" }
  ];

  const rtoOptions = [
    { value: "", label: "All RTO" },
    { value: "mp09", label: "MP09 - Indore" },      // ✅ Correct
    { value: "mp20", label: "MP20 - Ujjain" },      // ✅ Correct
    { value: "mp21", label: "MP21 - Dewas" },       // ✅ Correct
    { value: "mp22", label: "MP22 - Mhow" },        // ✅ Correct
    { value: "dl", label: "DL - Delhi" },           // ✅ Correct
    { value: "mh", label: "MH - Maharashtra" },     // ✅ Correct
    { value: "ka", label: "KA - Karnataka" },       // ✅ Correct
    { value: "tn", label: "TN - Tamil Nadu" },      // ✅ Correct
    { value: "up", label: "UP - Uttar Pradesh" }    // ✅ Correct
  ];

  const ownerTypeOptions = [
    { value: "", label: "All Owners" },
    { value: "first", label: "1st Owner" },
    { value: "second", label: "2nd Owner" },
    { value: "third", label: "3rd Owner" },
    { value: "fourth_plus", label: "4th+ Owner" }
  ];

  const availabilityOptions = [
    { value: "", label: "All Availability" },
    { value: "in_stock", label: "In Stock" },
    { value: "booked", label: "Booked" },
    { value: "upcoming", label: "Upcoming" }
  ];

  const handleFilterChange = (filterName, value) => {
    let newFilters = { ...filters, [filterName]: value };
    
    if (filterName === "brand") {
      newFilters.model = "";
    }
    
    setFilters(newFilters);
    console.log("🔍 Filter changed:", filterName, "=", value);
    onFilterChange(newFilters);
  };

  const handlePriceRangeChange = (minPrice, maxPrice) => {
    const newFilters = {
      ...filters,
      minPrice: minPrice.toString(),
      maxPrice: maxPrice.toString(),
      budget: ""
    };
    setFilters(newFilters);
    console.log("💰 Price range changed:", minPrice, "-", maxPrice);
    onFilterChange(newFilters);
  };

  const handleBrandClick = (brandName) => {
    if (expandedBrand === brandName) {
      setExpandedBrand(null);
    } else {
      setExpandedBrand(brandName);
    }
  };

  const handleModelClick = (brandName, modelName) => {
    const newFilters = {
      ...filters,
      brand: brandName,
      model: modelName
    };
    setFilters(newFilters);
    console.log(`🚗 Selected: ${brandName} - ${modelName}`);
    onFilterChange(newFilters);
    setShowBrandDropdown(false);
  };

  const handleViewAllBrand = (brandName) => {
    const newFilters = {
      ...filters,
      brand: brandName,
      model: ""
    };
    setFilters(newFilters);
    console.log(`🏢 Viewing brand: ${brandName}`);
    onFilterChange(newFilters);
    setShowBrandDropdown(false);
  };

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const clearAllFilters = () => {
    const emptyFilters = Object.keys(filters).reduce((acc, key) => {
      acc[key] = "";
      return acc;
    }, {});
    setFilters(emptyFilters);
    onFilterChange(emptyFilters);
    setExpandedBrand(null);
    setShowBrandDropdown(false);
    navigate("/buy-cars");
  };

  const activeFiltersCount = Object.values(filters).filter(v => v !== "").length;
  const allBrands = Object.keys(BRANDS_MODELS).sort();
  // const currentBrandModels = filters.brand ? BRANDS_MODELS[filters.brand] : [];
  const currentBrandModels = filters.brand? (BRANDS_MODELS[filters.brand] || []): [];

  return (
    <div className="search-filters-sidebar">
      <div className="filters-header">
        <h2>🔍 Filter Cars</h2>
      </div>

      <div className="filter-sections-container">
        
        {/* PRICE RANGE SLIDER */}
        <div className="filter-section price-range-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('priceRange')}
          >
            <h3>Price Range</h3>
            <span className="toggle-icon">{expandedSections.priceRange ? '▼' : '▶'}</span>
          </div>
          
          {expandedSections.priceRange && (
            <div className="filter-section-content price-slider-content">
              <PriceRangeSlider
                minPrice={filters.minPrice ? parseInt(filters.minPrice) : null}
                maxPrice={filters.maxPrice ? parseInt(filters.maxPrice) : null}
                onPriceChange={handlePriceRangeChange}
              />
            </div>
          )}
        </div>

        {/* BRAND WITH NESTED MODELS */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('brand')}
          >
            <h3>Brand</h3>
            <span className="toggle-icon">{expandedSections.brand ? '▼' : '▶'}</span>
          </div>
          
          {expandedSections.brand && (
            <div className="filter-section-content">
              <div className="brand-dropdown-wrapper">
                <button 
                  className="brand-dropdown-toggle"
                  onClick={() => setShowBrandDropdown(!showBrandDropdown)}
                >
                  <span>{filters.brand ? filters.brand : "Select Brand"}</span>
                  <span className="dropdown-arrow">{showBrandDropdown ? '▲' : '▼'}</span>
                </button>

                {showBrandDropdown && (
                  <div className="brand-dropdown-menu">
                    <button 
                      className="all-brands-btn"
                      onClick={() => {
                        handleViewAllBrand("");
                        setExpandedBrand(null);
                      }}
                    >
                      All Brands
                    </button>
                    
                    <div className="brands-list">
                      {allBrands.map((brandName) => (
                        <div key={brandName} className="brand-item-dropdown">
                          <button
                            className={`brand-btn-dropdown ${filters.brand === brandName ? 'selected' : ''}`}
                            onClick={() => handleBrandClick(brandName)}
                          >
                            <span className="brand-name">{brandName}</span>
                            <span className="expand-icon">
                              {expandedBrand === brandName ? '▼' : '▶'}
                            </span>
                          </button>

                          {expandedBrand === brandName && (
                            <div className="models-list-filter">
                              {BRANDS_MODELS[brandName].map((modelName) => (
                                <button
                                  key={modelName}
                                  className={`model-btn-filter ${filters.model === modelName && filters.brand === brandName ? 'selected' : ''}`}
                                  onClick={() => handleModelClick(brandName, modelName)}
                                >
                                  {modelName}
                                </button>
                              ))}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {filters.brand && currentBrandModels.length > 0 && (
                  <div className="model-selector-wrapper">
                    <label className="model-label">Models</label>
                    <select 
                      value={filters.model}
                      onChange={(e) => handleFilterChange("model", e.target.value)}
                      className="filter-select-sidebar"
                    >
                      <option value="">All Models</option>
                      {currentBrandModels.map(model => (
                        <option key={model} value={model}>{model}</option>
                      ))}
                    </select>
                  </div>
                )}
              </div>
            </div>
          )}
        </div>

        {/* LOCATION */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('location')}
          >
            <h3>Location (Car Hubs)</h3>
            <span className="toggle-icon">{expandedSections.location ? '▼' : '▶'}</span>
          </div>
          {expandedSections.location && (
            <div className="filter-section-content">
              <select 
                value={filters.location} 
                onChange={(e) => handleFilterChange("location", e.target.value)}
                className="filter-select-sidebar"
              >
                {locationOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* TRANSMISSION */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('transmission')}
          >
            <h3>Transmission</h3>
            <span className="toggle-icon">{expandedSections.transmission ? '▼' : '▶'}</span>
          </div>
          {expandedSections.transmission && (
            <div className="filter-section-content">
              <select 
                value={filters.transmission} 
                onChange={(e) => handleFilterChange("transmission", e.target.value)}
                className="filter-select-sidebar"
              >
                {transmissionOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* ✅ COLOR FILTER */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('color')}
          >
            <h3>Color</h3>
            <span className="toggle-icon">{expandedSections.color ? '▼' : '▶'}</span>
          </div>
          {expandedSections.color && (
            <div className="filter-section-content">
              <div className="color-grid">
                {colorOptions.map(opt => (
                  <button
                    key={opt.value}
                    className={`color-option ${filters.color === opt.value ? 'selected' : ''}`}
                    onClick={() => handleFilterChange("color", opt.value)}
                  >
                    {opt.color && (
                      <span 
                        className="color-circle" 
                        style={{ 
                          backgroundColor: opt.color,
                          border: opt.value === "White" ? "2px solid #ddd" : "none"
                        }}
                      />
                    )}
                    <span className="color-label">{opt.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
        </div>

        {/* BUDGET PRESETS */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('budget')}
          >
            <h3>Budget Presets</h3>
            <span className="toggle-icon">{expandedSections.budget ? '▼' : '▶'}</span>
          </div>
          {expandedSections.budget && (
            <div className="filter-section-content">
              <select 
                value={filters.budget} 
                onChange={(e) => {
                  const newFilters = {
                    ...filters,
                    budget: e.target.value,
                    minPrice: "",
                    maxPrice: ""
                  };
                  setFilters(newFilters);
                  onFilterChange(newFilters);
                }}
                className="filter-select-sidebar"
              >
                {budgetOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* FUEL TYPE */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('fuelType')}
          >
            <h3>Fuel Type</h3>
            <span className="toggle-icon">{expandedSections.fuelType ? '▼' : '▶'}</span>
          </div>
          {expandedSections.fuelType && (
            <div className="filter-section-content">
              <select 
                value={filters.fuelType} 
                onChange={(e) => handleFilterChange("fuelType", e.target.value)}
                className="filter-select-sidebar"
              >
                {fuelTypeOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* BODY TYPE */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('bodyType')}
          >
            <h3>Body Type</h3>
            <span className="toggle-icon">{expandedSections.bodyType ? '▼' : '▶'}</span>
          </div>
          {expandedSections.bodyType && (
            <div className="filter-section-content">
              <select 
                value={filters.bodyType} 
                onChange={(e) => handleFilterChange("bodyType", e.target.value)}
                className="filter-select-sidebar"
              >
                {bodyTypeOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* ✅ SEATS FILTER */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('seats')}
          >
            <h3>Seats</h3>
            <span className="toggle-icon">{expandedSections.seats ? '▼' : '▶'}</span>
          </div>
          {expandedSections.seats && (
            <div className="filter-section-content">
              <select 
                value={filters.seats} 
                onChange={(e) => handleFilterChange("seats", e.target.value)}
                className="filter-select-sidebar"
              >
                {seatsOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* ✅ RTO FILTER */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('rto')}
          >
            <h3>RTO</h3>
            <span className="toggle-icon">{expandedSections.rto ? '▼' : '▶'}</span>
          </div>
          {expandedSections.rto && (
            <div className="filter-section-content">
              <select 
                value={filters.rto} 
                onChange={(e) => handleFilterChange("rto", e.target.value)}
                className="filter-select-sidebar"
              >
                {rtoOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* ✅ OWNER TYPE FILTER */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('ownerType')}
          >
            <h3>Owner Type</h3>
            <span className="toggle-icon">{expandedSections.ownerType ? '▼' : '▶'}</span>
          </div>
          {expandedSections.ownerType && (
            <div className="filter-section-content">
              <select 
                value={filters.ownerType} 
                onChange={(e) => handleFilterChange("ownerType", e.target.value)}
                className="filter-select-sidebar"
              >
                {ownerTypeOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* ✅ AVAILABILITY FILTER */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('availability')}
          >
            <h3>Availability</h3>
            <span className="toggle-icon">{expandedSections.availability ? '▼' : '▶'}</span>
          </div>
          {expandedSections.availability && (
            <div className="filter-section-content">
              <select 
                value={filters.availability} 
                onChange={(e) => handleFilterChange("availability", e.target.value)}
                className="filter-select-sidebar"
              >
                {availabilityOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* ✅ YEAR FILTER */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('year')}
          >
            <h3>Year</h3>
            <span className="toggle-icon">{expandedSections.year ? '▼' : '▶'}</span>
          </div>
          {expandedSections.year && (
            <div className="filter-section-content">
              <select 
                value={filters.year} 
                onChange={(e) => handleFilterChange("year", e.target.value)}
                className="filter-select-sidebar"
              >
                {yearOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>

        {/* KM DRIVEN */}
        <div className="filter-section">
          <div 
            className="filter-section-header"
            onClick={() => toggleSection('kmDriven')}
          >
            <h3>KM Driven</h3>
            <span className="toggle-icon">{expandedSections.kmDriven ? '▼' : '▶'}</span>
          </div>
          {expandedSections.kmDriven && (
            <div className="filter-section-content">
              <select 
                value={filters.kmDriven} 
                onChange={(e) => handleFilterChange("kmDriven", e.target.value)}
                className="filter-select-sidebar"
              >
                {kmDrivenOptions.map(opt => (
                  <option key={opt.value} value={opt.value}>{opt.label}</option>
                ))}
              </select>
            </div>
          )}
        </div>
      </div>

      {/* Clear All Button */}
      {activeFiltersCount > 0 && (
        <div className="filters-footer">
          <button className="clear-all-btn-bottom" onClick={clearAllFilters}>
            ✕ Clear All Filters ({activeFiltersCount})
          </button>
        </div>
      )}
    </div>
  );
};

export default SearchFilters;